import React from 'react';
import { useDispatch } from 'react-redux';
import { apiAction } from '../../../store/generalSlice';
import { compareArrayOfInt } from '../../../utils/helpers';
import { Link } from 'react-router-dom';

const Targeting = (props) => {
  const dispatch = useDispatch();
  const { action, fieldName, field, objectField, state, setState } = props;
  const updateValue = (e, fieldName) => {
    setState((prevState) => {
      if (typeof prevState[field.id].value !== 'object') {
        return {
          ...prevState,
          [field.id]: {
            ...prevState[field.id],
            value: { [fieldName]: e.target.value },
          },
        };
      }
      return {
        ...prevState,
        [field.id]: {
          ...prevState[field.id],
          value: { ...prevState[field.id].value, [fieldName]: e.target.value },
        },
      };
    });
  };

  const SaveButton = () => {
    return (
      <>
        <button
          className='btn btn-sm btn-success mt-2'
          onClick={() => {
            dispatch(
              apiAction({
                reduxField: 'action',
                route: `actions/updateDuplicateAction`,
                actionId: action._id,
                fieldName,
                changes: { ...state },
              }),
            );
          }}
        >
          Save
        </button>
      </>
    );
  };

  return field && state && setState ? (
    <div key={field.id} className='col-md-6 p-3 border'>
      <label>
        <b>Targeting: </b>
        Targeting settings
      </label>
      <div>
        <label>age_min</label>
        <input
          type='number'
          className='form-control'
          defaultValue={typeof state[field.id]?.value === 'object' ? state[field.id].value.age_min : undefined}
          disabled={state[field.id] ? state[field.id].isUseSource : null}
          onChange={(e) => updateValue(e, 'age_min')}
        />
        {state[field.id]?.value?.age_min !== action[fieldName][field.id]?.value?.age_min ? <SaveButton /> : null}
      </div>

      <div className='mt-2'>
        <label>age_max</label>
        <input
          type='number'
          className='form-control'
          defaultValue={typeof state[field.id]?.value === 'object' ? state[field.id].value.age_max : undefined}
          disabled={state[field.id] ? state[field.id].isUseSource : null}
          onChange={(e) => updateValue(e, 'age_max')}
        />
        {state[field.id]?.value?.age_max !== action[fieldName][field.id]?.value?.age_max ? <SaveButton /> : null}
      </div>
      <div className='mt-2'>
        <label className='mr-2'>genders</label>

        {(() => {
          const formStateGenders = Array.isArray(state.targeting?.value?.genders) ? state.targeting.value.genders : [];
          const actionGenders = Array.isArray(action[fieldName][field.id]?.value?.genders)
            ? action[fieldName][field.id].value.genders
            : [];
          const genderButtons = [
            { value: 1, label: '1 - Male' },
            { value: 2, label: '2 - Female' },
          ];
          return (
            <>
              {genderButtons.map((button) => (
                <button
                  key={`gButton${button.value}`}
                  className={`mr-1 btn btn-sm btn${formStateGenders.includes(button.value) ? '' : '-outline'}-primary`}
                  disabled={state[field.id] ? state[field.id].isUseSource : null}
                  onClick={() => {
                    if (!formStateGenders.length) {
                      return updateValue({ target: { value: [button.value] } }, 'genders', true);
                    }
                    if (formStateGenders.includes(button.value)) {
                      return updateValue(
                        { target: { value: formStateGenders.filter((flt) => flt !== button.value) } },
                        'genders',
                        true,
                      );
                    }
                    return updateValue({ target: { value: [...formStateGenders, button.value] } }, 'genders', true);
                  }}
                >
                  {button.label}
                </button>
              ))}
              {!compareArrayOfInt(actionGenders, formStateGenders) ? <SaveButton /> : null}
            </>
          );
        })()}
      </div>
      <div>
        <Link
          className='btn btn-sm btn-outline-primary mt-4'
          to={`/EditAllTargetingFields/${objectField}/${fieldName}/${action._id}`}
        >
          Edit All Targeting Fields
        </Link>
      </div>

      <div>
        <div className='form-check mt-2'>
          <input
            type='checkbox'
            className='form-check-input'
            checked={state[field.id] ? state[field.id].isUseSource : null}
            onChange={(e) => {
              setState((prevState) => {
                return {
                  ...prevState,
                  [field.id]: { ...prevState[field.id], isUseSource: e.target.checked },
                };
              });
              dispatch(
                apiAction({
                  reduxField: 'action',
                  route: `actions/updateDuplicateAction`,
                  actionId: action._id,
                  fieldName,
                  changes: { ...state, [field.id]: { ...state[field.id], isUseSource: e.target.checked } },
                }),
              );
            }}
          />
          <label className='form-check-label'>Use Source</label>
        </div>
      </div>
    </div>
  ) : null;
};

export default Targeting;
